module.exports = __webpack_public_path__ + "img/success-icon.6afdbf09.png";